module.exports = __webpack_public_path__ + "img/cost.ad7d44c6.svg";